import {getDynamicPages} from '@/services/content/appContent';
import {DynamicPageSectionItems} from '@/types/aem';
import {asDynamicPageSections, type DynamicPageSectionModel} from '@/types/dynamicPages';
import arrayUtils from '@/utils/arrayUtils';
import {twx} from '@/utils/tailwindUtils';

import BadgesCollectionSection from '@/views/BadgesCollectionSection/BadgesCollectionSection';
import BadgesInProgressCollectionSection from '@/views/BadgesInProgressCollectionSection/BadgesInProgressCollectionSection';
import BadgesInProgressSection from '@/views/BadgesInProgressSection/BadgesInProgressSection';
import HeaderSection from '@/views/HeaderSection/HeaderSection';
import TabbedRewardsSection from '@/views/TabbedRewardsSection/TabbedRewardsSection';

import DynamicPageSection from './DynamicPageSection';

type DynamicPageProps = {
    pageId: string;
    className?: string;
};

const renderSection = (section: DynamicPageSectionModel, index: number) => {
    const {type, id} = section;
    const key = `${type}-${index}`;

    switch (type) {
        case DynamicPageSectionItems.HeaderSection:
            return (
                <DynamicPageSection key={key} id={id}>
                    <HeaderSection content={section.content} />
                </DynamicPageSection>
            );

        case DynamicPageSectionItems.BadgesInProgressSection:
            return (
                <DynamicPageSection key={key} id={id}>
                    <BadgesInProgressSection content={section.content} />
                </DynamicPageSection>
            );

        case DynamicPageSectionItems.BadgesCollectionSection:
            return (
                <DynamicPageSection key={key} id={id}>
                    <BadgesCollectionSection />
                </DynamicPageSection>
            );

        case DynamicPageSectionItems.BadgesInProgressCollectionSection:
            return (
                <DynamicPageSection key={key} id={id}>
                    <BadgesInProgressCollectionSection content={section.content} />
                </DynamicPageSection>
            );

        case DynamicPageSectionItems.TabbedRewardsSection:
            return (
                <DynamicPageSection key={key} id={id} className='flex min-h-0 flex-1 flex-col'>
                    <TabbedRewardsSection content={section.content} />
                </DynamicPageSection>
            );

        default:
            return null;
    }
};

const DynamicPage = ({pageId, className}: DynamicPageProps) => {
    const page = getDynamicPages().find((p) => p.id === pageId);
    if (!page) return null;

    const sections = asDynamicPageSections(arrayUtils.sortArrayWithOrderField(page.pageSections ?? []));

    return (
        <div className={twx('flex min-h-full w-full flex-col gap-2 bg-tnemec-black pt-4 text-romance', className)}>
            {sections.map(renderSection)}
        </div>
    );
};

export default DynamicPage;
